import {Divider, SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const StreamHeaderLoading: React.FC = () => {
  return (
    <Wrapper data-testid="StreamHeaderLoadingView">
      <HeadlineRow>
        <SkeletonBlock $width="30%" $height="24px" />
        <SortingSectionElements>
          <SkeletonBlock $width="130px" $height="32px" disableSpaceBelow />
          <SkeletonBlock $width="130px" $height="32px" disableSpaceBelow />
        </SortingSectionElements>
      </HeadlineRow>

      <Divider />
    </Wrapper>
  );
};

const Wrapper = styled.section`
  width: 100%;
`;

const HeadlineRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const SortingSectionElements = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
`;
